module.exports = __webpack_public_path__ + "img/scp_head_banner.8a8dbed4.png";